import axios from '@/plugins/axiosInstance'
import { suggestions } from '@/networking/urlManager'

export const fetchSuggestions = async (params = {}) => {
  try {
    const response = await axios.get(suggestions.getAll, { params })
    return response.data
  } catch (error) {
    console.error('Error fetching suggestions:', error)
    throw error
  }
}

export const fetchSuggestionById = async (id, params = {}) => {
  try {
    const response = await axios.get(suggestions.getOne.replace(':id', id), { params })
    return response.data
  } catch (error) {
    console.error(`Error fetching suggestion with id ${id}:`, error)
    throw error
  }
}

export const fetchSuggestionsByContentType = async (type, params = {}) => {
  try {
    const response = await axios.get(suggestions.byContentType.replace(':type', type), { params })
    return response.data
  } catch (error) {
    console.error(`Error fetching suggestions by content type ${type}:`, error)
    throw error
  }
}

export const fetchSuggestionsByCategory = async (category, params = {}) => {
  try {
    const response = await axios.get(suggestions.byCategory.replace(':category', category), { params })
    return response.data
  } catch (error) {
    console.error(`Error fetching suggestions by category ${category}:`, error)
    throw error
  }
}
